import React from "react";

class DownloadChromium extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            downloading: false
        };
    }

    handleDownload = () => {

        this.setState({
            downloading: true
        });

    };

    render() {

        const href = "https://ottodatas.easydirect.fr/chromium/Setup_FTVA_Chromium_150.msi";
        const { downloading } = this.state;

        return (
            <div style={styles.container}>

                <div style={styles.icon}>
                    ↓
                </div>

                <div style={styles.content}>
                    <div style={styles.title}>
                        Télécharger Chromium pour O.T.T.O
                    </div>

                    <div style={styles.description}>
                        Windows 11 V153
                    </div>
                </div>

                <a
                    href={href}
                    onClick={this.handleDownload}
                    style={{
                        ...styles.button,

                        background: downloading
                            ? "#555555"
                            : "linear-gradient(135deg, #0b6cff 0%, #004ecb 100%)",

                        color: downloading
                            ? "#aaaaaa"
                            : "#ffffff",

                        cursor: downloading
                            ? "default"
                            : "pointer",

                        pointerEvents: downloading
                            ? "none"
                            : "auto"
                    }}
                >
                    {downloading
                        ? "Téléchargement..."
                        : "Télécharger"
                    }
                </a>
            </div>
        );
    }
}


const styles = {

    container: {
        position: "absolute",
        top: "20px",
        left: "50px",

        display: "flex",
        alignItems: "center",

        width: "650px",

        padding: "18px 20px",

        background:
            "linear-gradient(135deg, #242424 0%, #111111 100%)",

        border: "1px solid #3d3d3d",
        borderRadius: "10px",

        boxShadow:
            "0px 4px 15px rgba(0,0,0,0.45)",

        fontFamily: "Arial, sans-serif",

        zIndex: 1000
    },

    icon: {
        width: "46px",
        height: "46px",

        display: "flex",
        alignItems: "center",
        justifyContent: "center",

        marginRight: "16px",

        fontSize: "28px",
        color: "#ffffff",

        background: "#333333",
        borderRadius: "8px"
    },

    content: {
        flex: 1
    },

    title: {
        fontSize: "17px",
        fontWeight: "bold",
        color: "#ffffff",

        marginBottom: "5px"
    },

    description: {
        fontSize: "13px",
        color: "#a8a8a8"
    },

    button: {
        marginLeft: "20px",

        padding: "10px 18px",

        color: "#ffffff",
        textDecoration: "none",

        fontSize: "14px",
        fontWeight: "bold",

        borderRadius: "6px",

        boxShadow:
            "0px 3px 8px rgba(0,0,0,0.4)",

        whiteSpace: "nowrap",

        transition: "background 0.3s, color 0.3s"
    }

};

export default DownloadChromium;